import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogos ,cargarCatalogosGenerico, cargarCatalogos_Otros, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { formatearFecha } from '../../funciones_globales/format';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { formatearLabel } from '../../funciones_globales/format';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

class FormCaja04 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Estados formulario
            operacion: 'G', //G & M
            permiso: 'G',
            ult_transaccion: null,
            num_diario: null,
            movimientoId: '',
            cod_proveedor: null,
            planVigente: null,
            cuentaContable: null,

            //FECHAS
            fechaEmision: null,
            fechaProceso: null,
            diasPermiteRetro: 0,

            //Estado - Transaccion
            cajaChicaStatus: null,
            cuentaCaja_sel: null,
            r_repCtasCaja: [],

            //CajaText
            ident_prov: null,
            cuenta: '',
            nombreProveedor: '',
            concepto: '',
            numero_doc: '',
            beneficiario: '',
            valor: '',
            observacion: '',
            
            //Selects
            tipoDoc_sel: null,
            opt_tipoDoc: [],
            opt_rubro: [],
            rubro_sel: null,

            docsCargados_sel: null,
            opt_docsCargados: [],
            opt_caja: [],
            caja_sel: null,

            //Auxiliar
            totalGrid: 0,
            estado: null,

            //Grids
            detCajaChica: [],
            columnsDefGridCajaChica: [       
                { header: "N°",
                  field: "Secuencia",
                  width: 30,
                  type: "string"
                },  
                { header: "Fecha",
                  field: "Fecha",
                  width: 70,
                  type: "string",
                  editable: false
                },
                {
                  header: "Tipo",
                  field: "Tipo",
                  width: 40,
                  type: "string"
                },
                { header: "Ident. Prov.",
                  field: "Id_proveedor",
                  width: 90,
                  type: "string"
                },
                { header: "Beneficiario",
                  field: "Beneficiario",
                  width: 155,
                  type: "string"
                },                
                { header: "Serie",
                  field: "Serie",
                  width: 50,
                  type: "string"
                },
                { header: "#. Fac.",
                  field: "Num_Factura",
                  width: 95,
                  type: "string"
                },
                { header: "Concepto",
                  field: "Concepto",
                  width: 180,
                  type: "string",
                  editable: false
                },
                {   header: "Rubro",
                    field: "Rubro_num",
                    width: 50,
                    type: "string"                                           
                },
                {   header: "Descripcion rubro",
                    field: "Rubro",
                    width: 150,
                    type: "string"                                           
                },
                { header: "Valor",
                  field: "Valor",
                  width: 75,
                  type: "num_decimal_edit",
                  editable: false
                },
                { header: "",
                  field: "eliminar",
                  width: 50,
                  type: "link_elim"                                                
                }
              ]
        };

        this.CajaChicaOptions = {
            context: {
                componentParent: this
            },
            enableCellChangeFlash: true,
            enableColResize: true,
            onRowDataChanged:((event)=>{
            }),
            onCellValueChanged:((event)=>{  
                //console.log("EVENT: ", event)
                //SE ACCIONA SIEMPRE EN MODIFICACIÓN
                switch (event.colDef.field) {
                    case "Valor":
                        if(isNaN(event.data.Valor)===true || event.data.Valor===""){
                            //RESET VALUE => no es número
                            event.data.Valor = event.oldValue
                        }else{
                            var valor_editado = 0;
                            var saldo = 0;

                            valor_editado = parseFloat(event.data.Valor);
                            saldo = parseFloat(event.data.Saldo);
                            if( (Math.round(valor_editado * 100)  / 100) > (Math.round(saldo * 100)  / 100)){
                                //RESET VALUE => EL VALOR SUPERA AL SALDO
                                event.data.Valor = event.oldValue;
                            }else{
                                //VALOR CORRECTO
                                event.data.Aplicado = valor_editado;
                            }
                        }
                        break;
                    
                    case "Fecha":
                        if(event.data.Fecha!==""){                                                        
                            event.data.Fecha = event.newValue;
                            //Validador de fecha invalida
                            var resultado;
                            resultado = validarFechaMomentEnFormatoString(event.newValue);
                            console.log("RESULTADO: ",resultado)
                            if(resultado===false){
                                event.data.Fecha = event.oldValue
                            }else{
                                let fechaValid = this.validarFechas(moment(event.data.Fecha, 'DD/MM/YYYY'), 
                                moment(formatearFechaMoment_a_String(this.state.fechaProceso), 'DD/MM/YYYY'), 
                                this.state.diasPermiteRetro)
                        
                                if(fechaValid.esValida===false){
                                    event.data.Fecha = event.oldValue;
                                    alert(fechaValid.msg);
                                }
                            }
                        }
                        break;
                
                    default:
                        break;
                }
                this.apiCajaChica.refreshCells();
            }),
            onCellEditingStarted:((event)=> {
            })
        };

        this.actualizarCamposCajaChica = this.actualizarCamposCajaChica.bind(this);
        this.getCajaChicaById = this.getCajaChicaById.bind(this);
        this.getProveedor = this.getProveedor.bind(this);
        this.clear = this.clear.bind(this);
        this.onGridCajaChicaReady = this.onGridCajaChicaReady.bind(this);
        this.addDetalle = this.addDetalle.bind(this);
        this.changeTipo = this.changeTipo.bind(this);
        this.changeIdProveedor = this.changeIdProveedor.bind(this);
        this.ingresoValores = this.ingresoValores.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
        this.guardarCajaChica = this.guardarCajaChica.bind(this);
        this.changeCaja = this.changeCaja.bind(this);
        this.anularCajaChica = this.anularCajaChica.bind(this);
        this.getOptions_Rubro = this.getOptions_Rubro.bind(this);
        this.imprimirCajaChica = this.imprimirCajaChica.bind(this);

        this.labelCajaChica = this.labelCajaChica.bind(this);
        this.saldoDocSel = this.saldoDocSel.bind(this);

        this.actualizarCabeceraGrid = this.actualizarCabeceraGrid.bind(this);
        this.changeStateHeader = this.changeStateHeader.bind(this);

        //CONTROL FECHAS
        this.actualizacionFechas = this.actualizacionFechas.bind(this);
    }

    //Change over controls
    actualizarCamposCajaChica(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
          [name]: value
        });
    }

    actualizarCabeceraGrid(){
        //Validacion columnas editables
        if(this.state.operacion === 'G'){
            //RESTABLECER GRID
            this.changeStateHeader('Concepto', false);
            this.changeStateHeader('Valor', false);
            this.changeStateHeader('Fecha', false);
        }else if(this.state.operacion === 'M'){
            //Modificación
            this.changeStateHeader('Concepto', true);
            this.changeStateHeader('Valor', true);
            this.changeStateHeader('Fecha', true);
        }
    }
        
        
    changeStateHeader(col_field, value){

        var col = this.columnApiCajaChica.getColumn(col_field);
        var colDef = col.getColDef();
        colDef.editable = value;
        this.apiCajaChica.refreshHeader();
    }

    onGridCajaChicaReady(params){
        this.apiCajaChica = params.api;
        this.columnApiCajaChica = params.columnApi;
    }

    changeTipo(value){
        
        if(value!==null){
            this.setState({tipoDoc_sel: value.value }, ()=>{
                this.clear();
                this.actualizacionFechas('U');
            }) 
        }else{
            this.setState({tipoDoc_sel: null }) 
            this.clear();
            this.actualizacionFechas('U')
        }
    }

    actualizacionFechas(op){
        let fechaProceso = getFechaProcesoPorModulo('05');

        if(op==='N'){
            this.setState({fechaProceso: moment(fechaProceso,'DD/MM/YYYY'),
            fechaEmision: moment(fechaProceso,'DD/MM/YYYY')})
        }else if(op === 'U'){
            this.setState({
                fechaEmision: moment(formatearFechaMoment_a_String(this.state.fechaProceso),'DD/MM/YYYY')
            })
        }
    }

    changeCaja(value){

        this.setState({cuentaCaja_sel:  null}, ()=>{
            if(value!==null){
                this.setState({caja_sel: value.value }, ()=>{
                    this.validarcuentaCaja(value.value);
                    this.clear();
                }) 
            }else{
                this.setState({caja_sel: null, tipoDoc_sel: null },()=>{
                })
                this.clear();
            }
        })
    }

    validarcuentaCaja(value){
        var conCuentaCaja = "";
        this.state.repCtasCaja.forEach((CUENTA)=>{
            if(CUENTA.Codigo === value){
                if(CUENTA.ConCuenta !== null){
                    conCuentaCaja = CUENTA.ConCuenta
                }
            }
        })
        if(conCuentaCaja !==""){
            this.setState({cuentaCaja_sel: conCuentaCaja})
        }else{            
            alert("La caja seleccionada no tiene una cuenta contable asignada")
        }
    }

    changeIdProveedor(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        if(value.length <=20){
            if(isNaN(value)===false){
                this.setState({[name]: value});
            }
        } 
    }

    ingresoValores(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox' ? target.checked : target.value;
        if(isNaN(value)===false){
            this.setState({
                [name]: value
              });
        }
    }

    //Operaciones
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject('Compra no existe o esta anulada...');
            });
        });
    }

    getCajaChicaById(){

        if(this.state.movimientoId === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.movimientoId,10) <= 0 ){
            alert("Movimiento no válido");
            this.clear();
        }else{

            global_axios({
                method: 'GET',
                url: '/caja/cajachica/'+this.state.movimientoId.toString()
            })
            .then((response)=> {
                var respuesta = response.data;
                var grid = [];

                this.setState({caja_sel: respuesta.Caja!==null?respuesta.Caja:'', cajaChicaStatus: respuesta.Estado});
                this.setState({observacion: respuesta.Observacion!==null?respuesta.Observacion:''});
                this.setState({operacion: 'M'}, ()=>{
                    this.actualizarCabeceraGrid();
                })

                if(respuesta.FechaProceso!==null){
                    var fechaProcess = formatearFecha(respuesta.FechaProceso.toString().substring(0,10))
                    console.log("FECHA: ", fechaProcess)
                    this.setState({fechaProceso: moment(fechaProcess,'DD/MM/YYYY'), fechaEmision: moment(respuesta.FechaProceso,'DD/MM/YYYY')})
                }

                if(respuesta.Estado){
                    let resp = "";
                    switch (respuesta.Estado) {
                        case 'A':
                            resp = 'ACTIVO'
                            break;
                        case 'I':
                            resp = 'INACTIVO'
                            break;
                        case 'C':
                            resp = 'CERRADO'
                            break;                    
                        default:                            
                            break;
                    }
                    this.setState({estado: resp})
                }
                
                console.log('RESPUESTA DESDE API:',respuesta);
                //Transformar Array a grid visible
                respuesta.detalle_cajachica.forEach((DATA, i)=>{
                    var item = {};
                        if(DATA.Doc === 'FAC' || DATA.Doc === 'LQC' || DATA.Doc === 'NTV'){
                            console.log("ENTRO", DATA.Doc)
                            item.Serie = DATA.CompraD.Establecimiento+''+DATA.CompraD.PuntoVenta;
                            item.Num_Factura = DATA.CompraD.Factura?DATA.CompraD.Factura.trim():'';
                            item.Id_proveedor = DATA.CompraD.provee!==null?DATA.CompraD.provee.CedulaRuc.trim():"";
                            item.Proveedor = DATA.Proveedor;
                            item.Compra = DATA.Compra;
                        }else{
                            item.Rubro_num = DATA.Rubro;
                            item.Rubro = this.getDescripcionRubro(DATA.Rubro);
                            item.Num_Factura = DATA.NumeroDoc?DATA.NumeroDoc.trim():''; 
                        }
                        if(DATA.Fecha!==null){
                            item.Fecha = formatearFecha(DATA.Fecha , 'DD/MM/YYYY');
                        }

                        item.Secuencia = i + 1;
                        item.Tipo = DATA.Doc;
                        item.Beneficiario = DATA.Beneficiario;                        
                        item.Concepto = DATA.Concepto;
                        item.Valor = DATA.Valor;

                        if(DATA.CompraD!==null){
                            item.Saldo = (Math.round(item.Valor *100)/100)+(Math.round(DATA.CompraD.Saldo *100)/100)
                        }
    
                        grid.push(item);
                    
                })

                this.setState({detCajaChica: grid, operacion: 'M'}, ()=>{
                    let valor = this.totallizarGrid();
                    this.setState({totalGrid: valor})
                });

            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }   
    }

    //FUNCTION AGREGADA PROVEEDOR
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getProveedor(){
        if(this.state.ident_prov !== null){
            var data = {}
            var cuenta = "";

            switch (this.state.tipoDoc_sel){
                case 'FAC':
                    data.Tipo = 'F'
                    break;
                case 'LQC':
                    data.Tipo = 'L'
                    break;
                case 'NTV':
                    data.Tipo = 'N'
                    break;
                default:
                    break;
            }

            this.cargarObjetos('/proveedores?tipo=indt_proveedor&ident='+this.state.ident_prov.value).then((result)=>{
                if(result.length > 0){
                    this.setState({nombreProveedor: result[0].Descripcion, cod_proveedor: result[0].CedulaRuc,
                        cuenta: (result[0].Tipo==='S')?result[0].CuentaContableServicio:result[0].Cuenta})//Willy 20191108
                        cuenta = (result[0].Tipo==='S')?result[0].CuentaContableServicio:result[0].Cuenta;//Willy 20191108
                    
                    if(cuenta === null || cuenta === ""){
                        alert("El Proveedor seleccionado no posee cuenta, antes de continuar edite el proveedor y asignele una cuenta")
                        this.clear();
                    }else{
                        this.cargarCuentasContables(cuenta.toString().trim(),this.state.planVigente).then((r_ctaContable)=>{
                            if(r_ctaContable===null){
                                this.setState({cuentaContable: null})
                                alert("La cuenta contable no se encuentra registrada en el plan: "+this.state.planVigente);
                            }else{
                                this.cargarObjetos('/compras?proveedor='+result[0].Codigo+'&tipo='+data.Tipo+'&status=P&status=E').then((result_docs)=>{
                            
                                    console.log("RESULT DOCS: ",result_docs)
                                    var arrayDocs = [], docsProcesados = [];
                                    
                                    arrayDocs = result_docs;
                                    if(arrayDocs.length>0){
                                        arrayDocs.forEach((DATA)=>{
                                            var item = {};
                                            var str = "";
                                            str = DATA.Establecimiento.toString().trim()+''+DATA.PuntoVenta.toString().trim()+'-'+DATA.Factura.toString().trim()
                                            item.value = DATA.Compra
                                            item.label = str
                                            item.Saldo = DATA.Saldo;
                                            item.Importe = DATA.Importe;
                                            docsProcesados.push(item);
                                        })
                                        this.setState({opt_docsCargados: docsProcesados, cuentaContable: r_ctaContable.Cuenta})
                                    }else{
                                        alert("El proveedor no tiene documentos pendientes")
                                    }
                                })
                            }
                        })
                    }
                }else{
                    this.setState({ident_prov:null}, ()=>{
                        if(result.length <= 0 && this.state.ident_prov===null){
                            alert('No existen coincidencias con el número de cédula ingresado');
                        }
                    })
                }
            })
        }
    }

    changeProveedor(value){

        if(value!==null){
            this.setState({ident_prov: value, docsCargados_sel: null,opt_docsCargados: [] })
        }else{
            this.setState({ident_prov: null, docsCargados_sel: null,opt_docsCargados: [] })
        }
    }

    getOptions_Rubro(input, callback){
        if (input.toString().length >= 3 ){            
            let cadena_busq = '?opcion=GASTO&cadena_busq='+input+'&plan='+this.state.planVigente
            cargarCatalogosGenericoAsync('/rubroscontables', cadena_busq, callback)  
        }
    }

    validarFechas(fechaEmision, fechaProceso, cantDias){
        var result;
        var fechaLimiteSuperior = fechaProceso
        if (fechaEmision.diff(fechaLimiteSuperior, 'days')>0){
            result = {esValida: false, msg: ('La fecha de emisión seleccionada no puede ser mayor que: ' + formatearFechaMoment_a_String(fechaProceso)) };
        }else{
            let fechaEmisionMinima = fechaLimiteSuperior.subtract(cantDias, 'days');
            if(fechaEmision.diff(fechaEmisionMinima)<0){
                result = {esValida: false, msg: ('La fecha de emisión seleccionada no puede ser menor que: ' + formatearFechaMoment_a_String(fechaEmisionMinima)) };
            }else{
                result = { esValida: true, msg: 'Fecha Ok'};
            }
        }
        return result;
    }
 
    cargarCuentasContables(cuenta, plan){
        return new Promise((resolve, reject) => {
            //CUENTA + PLANVIGENTE
            global_axios.get('/cuentas/'+cuenta+'/'+plan)
            .then((response)=>{                
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    addDetalle(){
        var mensaje = "";
        var proceder = true;
        var item = {};

        
        let fechaValid = this.validarFechas(this.state.fechaEmision, 
            moment(formatearFechaMoment_a_String(this.state.fechaProceso), 'DD/MM/YYYY'), 
            this.state.diasPermiteRetro)

        if(fechaValid.esValida===false){
            proceder = false;
            mensaje = mensaje+fechaValid.msg+"\n"
        }

        if(this.state.tipoDoc_sel === 'FAC' || this.state.tipoDoc_sel === 'LQC' || this.state.tipoDoc_sel === 'NTV'){
            if (this.state.ident_prov === null){
                mensaje = "- No ha cargado un proveedor.\n"
                proceder = false;
            }
            if (this.state.docsCargados_sel === null){
                mensaje = mensaje+"- No ha seleccionado un documento.\n"
                proceder = false;
            }
            if (this.state.concepto === ''){   
                mensaje = mensaje+"- No ha ingresado un concepto.\n"
                proceder = false;   
            }
            if(this.state.valor === ''){
                mensaje = mensaje+"- No ha ingresado un valor.\n" 
                proceder = false;  
            }else{
                var saldo = parseFloat(this.state.docsCargados_sel.Saldo, 10);
                if(saldo===0 && this.state.operacion==='M'){
                    saldo = parseFloat(this.state.docsCargados_sel.Importe, 10);
                }

                var valor = parseFloat(this.state.valor, 10);
                if((Math.round(valor * 100 ) / 100) > (Math.round(saldo * 100 ) / 100)){
                    mensaje = mensaje+"- El valor ingresado supera al de la compra.\n" 
                    proceder = false; 
                }
            }
            

        }else if(/*this.state.tipoDoc_sel === 'NTV' ||*/ this.state.tipoDoc_sel === 'VAL'){
            // if (this.state.numero_doc === ""){  
            //     mensaje = mensaje+"- No ha ingresado un número al documento.\n"  
            //     proceder = false;
            // }
            if (this.state.concepto === ''){   
                mensaje = mensaje+"- No ha ingresado un concepto.\n"
                proceder = false; 
            }if(this.state.rubro_sel === null){
                mensaje = mensaje+"- No ha seleccionado un rubro.\n" 
                proceder = false;    
            }if(this.state.valor === ''){
                mensaje = mensaje+"- No ha ingresado un valor.\n" 
                proceder = false;  
            }

        }

        if(proceder === false){
            alert(mensaje)
        }else{          
            if(this.state.tipoDoc_sel === 'FAC' || this.state.tipoDoc_sel === 'LQC' || this.state.tipoDoc_sel === 'NTV'){
                
                item.Id_proveedor = this.state.cod_proveedor;
                item.Proveedor = this.state.ident_prov.value;
                item.Beneficiario = this.state.nombreProveedor.toString().toUpperCase();
                item.Cuenta = this.state.cuenta;
                item.Compra = this.state.docsCargados_sel.value
                var docspart = [];
                docspart = this.state.docsCargados_sel.label.split("-");
                item.Serie = docspart[0];
                item.Num_Factura = docspart[1];  

            }else{
                item.Beneficiario = this.state.beneficiario.toString().toUpperCase();
                item.Num_Factura = this.state.numero_doc;
                item.Rubro_num = this.state.rubro_sel.value;
                item.Rubro = formatearLabel(this.state.rubro_sel.label)//this.getDescripcionRubro(item.Rubro_num);
            }

            item.Fecha = formatearFechaMoment_a_String(this.state.fechaEmision);
            item.Tipo = this.state.tipoDoc_sel;
            item.Concepto = this.state.concepto.toString().toUpperCase();;
            item.Valor = this.state.valor;

            this.setState({ detCajaChica: this.immutablePush(this.state.detCajaChica, item)}, ()=>{
                let total = this.totallizarGrid();
                total = Math.round((total)*100)/100;
                this.setState({totalGrid: total})

                this.state.detCajaChica.forEach((item, i)=>{
                    item.Secuencia = i+1;      
                });
    
                this.apiCajaChica.refreshCells();
            })
            this.clear();
        }
    }

    getDescripcionRubro(param){
        var valor = param.toString().trim();
        var resultado = "";
        this.state.opt_rubro.forEach((RUBRO)=>{
            if(RUBRO.value.toString().trim() === valor){
                resultado = RUBRO.label;
            }
        })
        return formatearLabel(resultado);
    }

    cargarOtrosCatchResult(tipo, name){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    //Funcion que recibe parametros de la fila para eliminar
    methodFromParent(id, datos_fila){
        var mensaje;
        mensaje = window.confirm("¿Desea eliminar el registro?"); 
        
        if (mensaje){
            this.eliminarDetalle(datos_fila ,id) 
        }
    }

    eliminarDetalle(datos_fila ,id){
        this.setState({ detCajaChica: this.immutableDelete(this.state.detCajaChica, id)}, ()=>{
            let total = this.totallizarGrid();
            this.setState({totalGrid: total});

            this.state.detCajaChica.forEach((item, i)=>{
                item.Secuencia = i+1;      
            });

            this.apiCajaChica.refreshCells();
        })
    }

    guardarCajaChica(){
        var errors = "";
        var proceder = true;
        var data = {};

        let fechaProceso = getFechaProcesoPorModulo('05');

        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.props.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(this.state.observacion === ""){
            proceder = false;
            errors = errors+'- Ingrese una observación antes de continuar.\n'
        }

        if(proceder === false){
            alert(errors);
        }

        
        if(proceder === true && this.state.cajaChicaStatus !== 'C'){
            var detCajaChica = [];

            data.Localidad = '01';
            data.Movimiento = '';
            data.Caja = this.state.caja_sel.toString();
            data.Estado = 'A';
            data.Observacion = this.state.observacion.toString().trim();
            data.Usuario = this.props.usuario;
            data.FechaProceso = formatearFechaMoment_a_String(this.state.fechaProceso);
            data.FechaSistema = '';
            data.IdRegAudit = this.props.IdRegAudit;
            //Campos moneda
            data.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
            data.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
            
            this.state.detCajaChica.forEach((DATA, i)=>{
                var item = {};
                if(DATA.Tipo==='FAC' || DATA.Tipo==='LQC' || DATA.Tipo==='NTV'){

                    item.Beneficiario = DATA.Beneficiario;
                    item.Proveedor = DATA.Proveedor;
                    item.Compra = DATA.Compra;
                }else if(DATA.Tipo==='VAL'){
                    item.Beneficiario = DATA.Beneficiario;
                    item.Rubro = DATA.Rubro_num;
                    item.NumeroDoc = DATA.Num_Factura;
                }

                //Datos Generales
                item.Localidad = '01';
                item.Movimiento = ''; //Movimiento dado en la API
                item.Secuencia = i + 1;                
                item.Doc = DATA.Tipo;                
                item.Concepto = DATA.Concepto;
                item.Valor = Math.round(parseFloat(DATA.Valor)* 100)/ 100;
                item.Fecha = DATA.Fecha;
                detCajaChica.push(item);
            })

            data.detCajaChica = detCajaChica;

            let config_request = {
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: this.state.operacion==='G'?'/caja/cajachica':'/caja/cajachica/'+this.state.movimientoId,
                data
            }
            console.log("ENVIA DATA: ", data);
            global_axios(config_request)
            .then((response)=> {             
                alert(response.data.msg);
                console.log("SEC: ", response.data)
                this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.diario})
                this.limpiarPantalla();
                this.setState({operacion: 'G', movimientoId: response.data.transaction}, ()=>{
                    this.actualizarCabeceraGrid();
                    this.getCajaChicaById();
                });
            })
            .catch((error)=>{                  
                alert(error.response?error.response.data.msg:error.message);                
            });
        }else if(this.state.cajaChicaStatus === 'C'){
            alert("Movimiento con reposición, no es posible actualizarlo")
        }
    }

    anularCajaChica(){
        var errors = "";
        var proceder = true;

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.props.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        // if(this.state.operacion === 'M' && this.state.permiso === 'M'){
        //     proceder = true;

        // }else if(this.state.operacion === 'M' && this.state.permiso !== 'M'){
        //     proceder = false;
        //     errors = errors+"- Solo supervisor puede ejercer cambios sobre los movimientos.\n"
        // }

        if(proceder === false){
            alert(errors);
        }

        if(proceder === true){
            global_axios({
                url: '/caja/cajachica/'+this.state.movimientoId,
                method: 'DELETE',
                headers: {'idregaudit': this.props.IdRegAudit}
              })
              .then((response)=>{
                alert(response.data.msg);
                this.setState({ult_transaccion: response.data.transaction})
                this.limpiarPantalla();
                this.setState({operacion: 'G'}, ()=>{
                    this.actualizarCabeceraGrid()});
              })
              .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);
                //this.limpiarPantalla();
            });
        }
    }

    clear(){        
        this.setState({ident_prov: null, cuenta: '', nombreProveedor: '',concepto: '',
        numero_doc: '',  valor: '', beneficiario: '', rubro_sel: null, cod_proveedor: null, opt_docsCargados: [],
        docsCargados_sel: null, cajaChicaStatus: null})

    }

    limpiarPantalla(param){
        this.clear();
        this.setState({detCajaChica: [], caja_sel: null, tipoDoc_sel: null,observacion: '', operacion: 'G',
        totalGrid: 0, estado: null},()=>{
            this.actualizarCabeceraGrid();
        });
        
        if(param==='A'){
            this.setState({movimientoId: ''});
            this.actualizacionFechas('N');
        }
    }
    
    componentDidMount(){
        Promise.all([
            this.cargarObjetos('/secuenciales/CajaChica'),
            cargarCatalogosGenerico('/caja'), 
            this.cargarOtrosCatchResult('CAJA-CTAS', 'repCtasCaja'),
            cargarCatalogos('TCOMPROCAJ'), 
            cargarCatalogos_Otros('GEN-PLANVIG'),
            cargarCatalogos_Otros('DIASRETRODOC'),
            this.props.generar_LogAuditoriaIngresoForm('0504')
         ])
        .then(([ secCaja, caja, r_repCtasCaja ,docsCajaChica, r_planVigente, r_diasRetroDoc ]) => {
            let fechaProceso = getFechaProcesoPorModulo('05');

            this.setState({ult_transaccion: parseInt(secCaja.codigo, 10)-1, opt_caja: caja, repCtasCaja: r_repCtasCaja ,opt_tipoDoc: docsCajaChica, 
            planVigente: r_planVigente[0].value , diasPermiteRetro: parseInt(r_diasRetroDoc[0].value, 10), permiso: this.props.permiso, 
            fechaProceso: moment(fechaProceso, "DD/MM/YYYY"),
            fechaEmision: moment(fechaProceso, "DD/MM/YYYY")})
        })
        .catch((error)=>{
            alert(error.response?error.response.data.msg:error.message)
        })

        
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0504');
    }

    //REPORTE

    imprimirCajaChica(){
        visualizarReporteEnPdf('&rpt=32&param1='+this.state.movimientoId)
    }

    labelCajaChica(){
        var respuesta = "Saldo Compra: "
        if(this.state.docsCargados_sel!==null){
            if(this.state.operacion==='M' && parseFloat(this.state.docsCargados_sel.Saldo, 10)===0){
                respuesta = 'Importe Compra: '
            }
        }else{
            respuesta = ''
        }

        return respuesta;
    }

    saldoDocSel(){
        if(this.state.docsCargados_sel!==null){
            if(Math.round(this.state.docsCargados_sel.Saldo * 100)/100 === 0 && this.state.operacion==='M'){
                return Math.round(this.state.docsCargados_sel.Importe * 100)/100
            }else{
                return Math.round(this.state.docsCargados_sel.Saldo * 100)/100
            }
        }else{
            return '';
        }
        
    }

    render(){
        const invisible = {display: 'none'};
        const visible = {display: 'block'};
        return(
            <ContenedorForm porc_ancho={80}>
             <HeaderForm>
                <TituloForm>Caja chica</TituloForm>
                <LabelCabecera>Estado: {this.state.estado}</LabelCabecera>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                <LabelCabecera>N°. diario: {this.state.num_diario}</LabelCabecera>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-sm-2' >
                                <LabelForm>Movimiento:</LabelForm>
                                <InputSearch tipoInput='text' nombre='movimientoId' placeholder='Movimiento' valor={this.state.movimientoId} func_CambiarValor={this.actualizarCamposCajaChica} 
                                func_BuscarValor={this.getCajaChicaById} func_OnFocus={()=>{this.limpiarPantalla('B')}} maxLength='10'/> 
                            </ContainerCol>
                            <ContainerCol className='col-md-3'>
                                <LabelForm>Caja:</LabelForm>
                                <ReactSelect disabled={this.state.detCajaChica.length>0?true:false} options={ this.state.opt_caja } value={this.state.caja_sel} 
                                func_onChange={(value)=>{this.changeCaja(value)}}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-2'>
                                <LabelForm>Tipo:</LabelForm>
                                <ReactSelect disabled={this.state.caja_sel===null?true:false} options={ this.state.opt_tipoDoc } value={this.state.tipoDoc_sel} func_onChange={(value)=>{this.changeTipo(value)}}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-2' style={this.state.cuenta===""?invisible:visible}>
                                <LabelForm>Cuenta Proveedor</LabelForm>
                                <InputText name="cuenta" disabled={true} value={this.state.cuenta} onChange={this.actualizarCamposCajaChica}/>
                            </ContainerCol>                            
                            <ContainerCol className={this.state.cuenta===""?'col-sm-2 col-md-offset-3':'col-sm-2 col-md-offset-1'}>
                                <LabelForm>Fecha:</LabelForm>
                                <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={!(this.props.permiteCambioFProceso==='S')} 
                                func_onChange={(fechaEscogida)=>{this.setState({fechaProceso: fechaEscogida})}}
                                />
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row style={this.state.tipoDoc_sel==='FAC' || this.state.tipoDoc_sel==='LQC' || this.state.tipoDoc_sel==='NTV'?visible:invisible}>
                        <ContainerCol className='col-sm-2 col-md-offset-10 col-sm-pull-10'>
                            <LabelForm>Fecha emisión:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaEmision} func_onChange={(fechaEscogida)=>{this.setState({fechaEmision: fechaEscogida})}}/>
                        </ContainerCol>
                    </Row>
                    <Row style={this.state.tipoDoc_sel==='FAC' || this.state.tipoDoc_sel==='LQC' || this.state.tipoDoc_sel==='NTV'?visible:invisible}>
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Id. Prov.:</LabelForm>
                            <ReactSelectAsync value={this.state.ident_prov} disabled={false} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.changeProveedor(value)}} func_onBlur={(value)=>{this.getProveedor(value)}} />
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Serie/Factura</LabelForm>
                            <ReactSelect disabled={this.state.opt_docsCargados.length >0?false:true} options={ this.state.opt_docsCargados } value={this.state.docsCargados_sel} func_onChange={(value)=>{this.setState({docsCargados_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5'>
                            <LabelForm>Concepto</LabelForm>
                            <InputText name="concepto" mayusculas={true} disabled={false} value={this.state.concepto} onChange={this.actualizarCamposCajaChica} maxLength='100'/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Valor</LabelForm>
                            <div className='input-group'>
                                <InputText autoComplete='off' name="valor" disabled={false} value={this.state.valor} onChange={this.ingresoValores} maxLength='7'/>
                                <span className='input-group-btn'>
                                    <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.addDetalle}><i className='fa fa-plus'></i></ButtonUnion>                
                                </span>
                            </div>
                        </ContainerCol>
                    </Row> 
                    <Row style={this.state.tipoDoc_sel==='VAL'?visible:invisible}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha emisión:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaEmision} func_onChange={(fechaEscogida)=>{this.setState({fechaEmision: fechaEscogida})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2 col-md-offset-6 col-sm-pull-6'>
                            <LabelForm>Número</LabelForm>
                            <InputText name="numero_doc" disabled={false} value={this.state.numero_doc} onChange={this.actualizarCamposCajaChica} maxLength='20'/>
                        </ContainerCol>
                        
                    </Row>
                    <Row style={this.state.tipoDoc_sel==='VAL'?visible:invisible}>
                        <ContainerCol className='col-sm-3 ' >
                            <LabelForm>Beneficiario</LabelForm>
                            <InputText name="beneficiario" mayusculas={true} disabled={false} value={this.state.beneficiario} onChange={this.actualizarCamposCajaChica} maxLength='50'/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Concepto</LabelForm>
                            <InputText name="concepto" mayusculas={true} disabled={false} value={this.state.concepto} onChange={this.actualizarCamposCajaChica} maxLength='80'/>
                        </ContainerCol>

                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Rubro:</LabelForm>
                            <ReactSelectAsync value={this.state.rubro_sel} func_loadOptions={this.getOptions_Rubro} func_onChange={(value)=>{this.setState({rubro_sel: value!==null?value:null})}}/>
                        </ContainerCol>

                        <ContainerCol className='col-sm-2 '>
                            <LabelForm>Valor</LabelForm>
                            <div className='input-group'>
                                <InputText autoComplete='off' name="valor" disabled={false} value={this.state.valor} onChange={this.ingresoValores} maxLength='7'/>
                                <span className='input-group-btn'>
                                    <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.addDetalle}><i className='fa fa-plus'></i></ButtonUnion>                
                                </span>
                            </div>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <LabelForm>Observaciones</LabelForm>
                            <InputText name="observacion" mayusculas={true} disabled={false} value={this.state.observacion} onChange={this.actualizarCamposCajaChica} maxLength='125'/>
                        </ContainerCol>
                    </Row>
                    <Row> 
                        <ContainerCol className='col-sm-12'>
                            <AgGridRender altura='150px' data={this.state.detCajaChica} columnas={this.state.columnsDefGridCajaChica}
                            gridOptions={this.CajaChicaOptions} onGridReady={this.onGridCajaChicaReady}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>{'Total:'} {this.state.totalGrid}</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>{this.labelCajaChica()} {this.saldoDocSel()}</LabelForm>
                        </ContainerCol>                     
                        <ContainerCol className='col-sm-8'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={(this.state.detCajaChica.length===0 || this.state.cuentaCaja_sel===null)&&this.state.operacion==='G'?true:false} onClick={this.guardarCajaChica}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('A')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                <button type='button' className='btn btn-danger btn-sm' disabled={this.state.detCajaChica.length>0&&this.state.operacion==='M'?false:true}onClick={this.anularCajaChica}><i className='fa fa-window-close  fa-lg'/> Anular</button>
                                <button type='button' className='btn btn-default btn-sm' disabled={this.state.movimientoId===''?true:false} onClick={this.imprimirCajaChica}><i className="fa fa-print fa-lg" aria-hidden="true"/> Rep. Caja Chica</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }

    totallizarGrid(){
        let acc = 0;
        this.state.detCajaChica.forEach((DET)=>{
            acc += parseFloat(DET.Valor, 10);
        })
        return Math.round(acc*100)/100;
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,}
  });
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormCaja04);